<template>
  <div id="app">
    <portal-target name="semantic-ui-vue"></portal-target>
<!--    <sui-menu id="nav" pointing secondary color="pink" class="mobile not">-->
<!--      <tab-link link="/" label="Overview" icon="home" :link-progress="false" />-->
<!--&lt;!&ndash;      <tab-link link="/" label="Tracking Devices" icon="mobile alternate" :link-progress="$store.state.device.inProgress" />&ndash;&gt;-->
<!--      <tab-link link="/account" label="Account" icon="address book outline" :link-progress="$store.state.inProgress" />-->
<!--      <tab-link link="/device" label="Tracking Devices" icon="mobile alternate" :link-progress="$store.state.device.inProgress" />-->
<!--      <tab-link link="/billing" label="SIM Plans" icon="credit card outline" :link-progress="$store.state.billing.inProgress" v-if="$store.getters['device/needForBilling']" />-->
<!--      <tab-link link="/admin" label="Admin" icon="user md" :link-progress="$store.state.admin.inProgress" v-if="$store.getters.isAdmin === true" />-->
<!--      <sui-menu-menu position="right">-->
<!--        <span v-if="isDevEnvironment"><span class="env">DEV</span></span>-->
<!--        <span is="sui-menu-item" disabled>{{$store.getters.userEmail}}</span>-->
<!--        <a is="sui-menu-item" content="Logout" @click="logout()"></a>-->
<!--      </sui-menu-menu>-->
<!--    </sui-menu>-->
    <div id="content">
<!--      <router-view/>-->
      <div class="content">
        <h3 is="sui-header" style="color: deeppink">This Locàite web page is not supported anymore!</h3>
        <p>
          We currently have mobile applications for both Apple IOS and Google Android platforms. Click on the following badges to download the applications.
        </p>
        <p class="badges">
          <a href="https://apps.apple.com/gb/app/loc%C3%A0ite/id1479473645"><img src="assets/app-store-badge-white.svg" class="badge apple"></a>
          <a href="https://play.google.com/store/apps/details?id=io.caite.locaite.app&gl=GB"><img src="assets/google-play-badge.png" class="badge google"></a>
        </p>
        <p>
          To set up billing away from the app, open your web browser and go to </p>
        <p>
          <a style="font-size: 130%; font-weight: bold" href="https://billing.caite.io">https://billing.caite.io</a>
        </p>
        </div>
      </div>
    </div>
</template>

<style lang="less">

  .mobile.only {
    display: none;
  }

  @media only screen and (max-width: 768px) {
    .mobile.only {
      display: block;
    }
    .mobile.not {
      display: none;
    }
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100%;
    max-width: 1200pt;
    position: absolute;
    padding: 0 10pt;
    top:0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    /*overflow-x: hidden;*/
  }

  #nav {
    a {
      &.router-link-exact-active {
        font-weight: bold !important;
        border-color: #e03997 !important;
        color: #e03997 !important;
      }
    }
  }
   #content {
     padding: 0 0pt;
   }

  .segment {
    margin: 0 !important;
  }
  .menu {
    margin-bottom: 0 !important;
  }
  .country-selector {
    margin-right: 6px;
  }
  .env {
    background: deeppink;
    color: white;
    padding: 2pt 10pt;
    margin-top: 6pt;
    display: inline-block;
  }

  .sticker {
    padding: 1pt 5pt;
    margin: 3pt;
    font-size: 9pt;
    border-radius: 3pt;
    &.blue {
      background: rgba(173, 216, 230, 0.25);
      color: #0e566c;
    }
    &.orange {
      background: lightgoldenrodyellow;
    }
    &.green {
      background: #d9ffd2;
      color: darkgreen;
    }
    &.darkolivegreen {
      background: darkolivegreen;
      color: white;
    }
    &.orangered {
      background: orangered;
      color: white;
    }
  }

  .full-screen {
    position: fixed;
    padding: 20pt;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: white;
    z-index: 2;
    max-height: 100%;
    overflow-y: auto;
  }
  .full-screen .actions {
    margin: 20pt 0pt;
    padding: 10pt;
    background: #FAFAFA;
    text-align: right;
  }
  .full-width {
    position: fixed;
    left: 0; right: 0;
  }

  /* enable basic browser text selection in grid cells */
  div.ag-root .ag-cell-focus {
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }

  .max-width-wrapper {
    max-width: 1200pt;
    margin: auto;
  }
  .visibility-hidden {
    visibility: hidden;
  }

  .content {
    padding: 10pt;
  }

  .badges {
    .badge {
      vertical-align: middle;
      max-height: 45pt;
    }
  }

</style>

<script>
  import EnvUtils from "./utils/EnvUtils";

  export default {
    components: {},
    methods: {
      logout() {
        this.$store.dispatch('logout')
      }
    },
    computed: {
      isDevEnvironment() {
        return EnvUtils.isdev();
      }
    },
    mounted() {
      // this.$store.dispatch('loadUserDetails')
      // this.$store.dispatch('device/loadDevices')
    }
  }
</script>
